import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CandidatesModule } from "./candidates/candidates.module";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { RequestsModule } from "./requests/requests.module";
import { BargainingModule } from "./bargaining/bargaining.module";
import { StatsModule } from "./stats/stats.module";

@NgModule({
  declarations: [],
  imports: [CommonModule, ContentHeaderModule, TranslateModule, Ng2FlatpickrModule, NgxDatatableModule, NgbTooltipModule, CandidatesModule, RequestsModule, BargainingModule, StatsModule],
})
export class RecruitmentModule {}
